export const GET_ALL_USERS_SUCCESS = "report/GET_ALL_USERS_SUCCESS";
export const GET_ALL_USERS_FAILURE  = "report/GET_ALL_USERS_FAILURE";